/**
 * This is a list of known faceting attributes for product search indexes.
 * Facets are defined and configured in the Algolia Dashboard https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/facet-display/js/#manage-facet-display-from-the-algolia-dashboard.
 * They can be different from index to index. This collection reflects
 * facets covered by filter components in the codebase.
 */
export const PRODUCT_SEARCH_FACET = {
  ABSORBENCY: 'absorbency',
  ACTIVE_SUBSTANCES: 'activeSubstances',
  ANIMAL_SPECIES: 'animal_species',
  APPLICATION_AREAS: 'application_areas',
  AUTHORS: 'authors',
  AVERAGE_RATING: 'averageRating',
  BOOK_LANGUAGE: 'book_language',
  BRAND_SEARCH: 'brandSearch',
  CERTIFICATES: 'certificates',
  DISCOUNT_IN_PERCENT: 'discountInPercent',
  DIVISIBILITY: 'divisibility',
  FILTER_ATTRIBUTES: 'filterAttributes',
  HAIR_COLOR: 'hair_color',
  HAIR_LENGTH: 'hair_length',
  HAIR_TYPE_MULTI: 'hair_type_multi',
  HAIRCUT: 'haircut',
  HEAD_CIRCUMFERENCE: 'head_circumference',
  LENS_TYPES: 'lens_types',
  LIFE_STAGE: 'life_stage',
  MANUFACTURER: 'manufacturer',
  MINERAL_AND_TRACE_ELEMENTS: 'mineral_and_trace_elements',
  NOW_PRODUCT_GROUP: 'nowProductGroup',
  PHARMA_FORM: 'pharmaForm',
  POTENCY: 'potency',
  PRESCRIPTION_MEDICINE: 'prescriptionMedicine',
  PRICE: 'price',
  PRIMARY_CATEGORY: 'primaryCategory',
  PRODUCT_TYPE_FILTER: 'product_type_filter',
  PUBLISHER: 'publisher',
  RECOMMENDED_AGE: 'recommended_age',
  SCHUESSLER_SALTS: 'schuessler_salts',
  SKIN_TYPE_MULTI: 'skin_type_multi',
  SPECIAL_NEEDS: 'special_needs',
  SPORTS: 'sports',
  TEXTURE: 'texture',
  UV_PROTECTION: 'uv_protection',
  VARIANTS_PACK_SIZE: 'variants.packSize',
  VARIETY: 'variety',
  VITAMINS: 'vitamins',
  VOLTAGE: 'voltage',
} as const

export type PRODUCT_SEARCH_FACET =
  (typeof PRODUCT_SEARCH_FACET)[keyof typeof PRODUCT_SEARCH_FACET]
